import { excludeFrom } from "@mcwd/typescript-type-guards";
import { DocumentFormSettingsKey, VideoFormSettingsKey, type AnyFormSettingsKey} from "../../form-settings/form-experience/form-settings-keys.js";

const AdditionalHeadings = [ "event-registration", "resource-forms", "contact", "qx-roi", "mx-roi" ] as const satisfies (AnyFormSettingsKey | "resource-forms")[];
type AdditionalHeadings = typeof AdditionalHeadings[ number ];

type SelectedFormTypes = Exclude<DocumentFormSettingsKey, "digital-maturity-assessment"> | VideoFormSettingsKey;
const SelectedFormTypes = [
  ...excludeFrom(DocumentFormSettingsKey, "digital-maturity-assessment"),
  ...VideoFormSettingsKey
] as const;

type FormKeyValues = SelectedFormTypes | AdditionalHeadings;
export type FormHeadingTranslationKey<TName extends string> =`${TName}-Heading`;
const FormSettingTypes = [ ...SelectedFormTypes, ...AdditionalHeadings] as const;

type FormMapType = FormHeadingTranslationKey<FormKeyValues>;
const FormSettingTypeMap = FormSettingTypes.map(x => `${x}-Heading` as const) satisfies FormMapType[];

export const FormHeadingTextKeys = [
  ...FormSettingTypeMap,
] as const;

export type FormHeadingKeys = typeof FormHeadingTextKeys[number];

export type FormHeadingTranslationObj = {
  readonly [Key in FormHeadingKeys]: string;
};